import { useState, useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import _ from "lodash";
import { checkKnownDateOrString, CustomMUIChip } from "../";

export function ItemDetails({ cellValues }) {
  const [detailsData, setDetailsData] = useState();

  useEffect(() => {
    let {
      userStatus,
      procurementStatus,
      supplierStatus,
      executiveChefStatus,
      HODStatus,
      isActive,
      markInactive,
      editItem,
      ...dataRest
    } = cellValues;

    setDetailsData(dataRest);
  }, [cellValues]);

  return (
    <Box>
      <Grid
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Grid item>
          <Typography variant="h6" component="h5" gutterBottom>
            <span style={{ paddingRight: "15px" }}>
              {" "}
              <b> Item Details</b>
            </span>
            {cellValues && (
              // Inactive only when explicitly false; missing isActive means
              // active (schema default true, legacy items lack it). QRM-8099.
              <CustomMUIChip
                label={cellValues?.isActive !== false ? "Active" : "Inactive"}
                status={cellValues?.isActive !== false}
                variant="outlined"
                color={
                  cellValues?.isActive !== false ? "success" : "error"
                }
              />
            )}
          </Typography>
          {detailsData &&
            Object.keys(detailsData).map((oneKey, i) => {
              return (
                <Grid
                  container
                  key={i}
                  style={{ fontSize: "14px", marginBottom: "5px" }}
                >
                  <Grid item xs={12} sm={5}>
                    <span>
                      {_.startCase(Object.keys(detailsData)[i]) + ":"}
                    </span>
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    <span>
                      {checkKnownDateOrString(oneKey, detailsData[oneKey])}
                    </span>
                  </Grid>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    </Box>
  );
}
